
<template>
  <div>
    <main>
      <slot></slot>
    </main>
  </div>
</template>
  <script setup>
</script>
  